import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import MaterialDivider from './MaterialDivider';

const AntibioticsAdditionForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Antibiotics Addition'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Antibiotic Type"
            name={`antibiotic_type-${data?.index}`}
            value={data?.antibiotic_type}
            onChange={e => 
              handleInputChange(e, data?.index, 'antibiotic_type', e.target.value)
            }
            helperText={formErrors[`antibiotic_type-${data?.index}`]}
            error={`antibiotic_type-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Dilution Factor"
            name={`dilution_factor-${data?.index}`}
            value={data?.dilution_factor}
            onChange={e => 
              handleInputChange(e, data?.index, 'dilution_factor', e.target.value)
            }
            helperText={formErrors[`dilution_factor-${data?.index}`]}
            error={`dilution_factor-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Payload concentration after dilution"
            name={`payload_concentration_after_dilution-${data?.index}`}
            value={data?.payload_concentration_after_dilution}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'payload_concentration_after_dilution', e.target.value
              )
            }
            helperText={
              formErrors[`payload_concentration_after_dilution-${data?.index}`]
            }
            error={`payload_concentration_after_dilution-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Antibiotic concentration"
            name={`antibiotic_concentration-${data?.index}`}
            value={data?.antibiotic_concentration}
            onChange={e => 
              handleInputChange(e, data?.index, 'antibiotic_concentration', e.target.value)
            }
            helperText={formErrors[`antibiotic_concentration-${data?.index}`]}
            error={`antibiotic_concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

AntibioticsAdditionForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default AntibioticsAdditionForm;